import moment from 'moment'
import { router } from './router'
import { store } from './store'
import { request, http } from './http'
import * as api from './api'
import { dev, routerQuery } from './utils'

export const enhance = {
  install(Vue, options) {
    Vue.filter('date', (v) => {
      return moment(v).format('YYYY-MM-DD')
    })

    Vue.filter('date_time', (v) => {
      if(v===undefined){
        return '-'
      }
      return moment(v).format('YYYY-MM-DD HH:mm:ss')
    })

    Vue.filter('expired', (v) => {
      if (!v) { return '无限期' }
      let ms = v - Date.now()
      if (ms <= 0) {
        return '过期'
      }
      let duration = moment.duration(ms)
      let n = duration.asYears()
      if (n >= 5) {
        return n.toFixed(0) + '年'
      }
      n = duration.asMonths()
      if (n >= 12) {
        return n.toFixed(0) + '月'
      }
      n = duration.asDays()
      return n.toFixed(0) + '天'
    })
    
    Vue.filter('route_name', v => {
      switch(v){
        case '1vs1/compare': return '人脸对比';
        case '6N1/compare':  return '6合1人脸对比';
        case '6N1/zz/compare': return '6合1众志人脸对比';
        case '122/compare':  return '122人脸对比';
        case 'bucket/compare': return '1:N查找';
        case '1vsV/compare':  return '证件照视频对比'
      }
    })

    Vue.filter('alive', v => {
      switch(v) {
        case 'UNREAL':
          return '非真人';
        case 'REAL':
          return '真人';
        case 'UNKNOWN':
          return '不确定';
        case 'FACESIZEMORETHANONE':
          return '传入人脸数>1'
        default:
          return '未知'
      }
    })

    Vue.filter('number', v => {
      if (isNaN(v)) { return '-' }
      return v.toLocaleString('en')
    })

    Vue.filter('user_name', id => {
      if (id !== 0 && !id) { return '-' }
      let user = Vue.store.getters['user/get']({ id })
      if (!user) { return '...' }
      return user.name || '未命名'
    })

    Vue.filter('department_name', no => {
      if (!no) { return '-' }
      let department = Vue.store.getters['department/getNo']({ no })

      if (!department) { return '...' }
      return department.name
    })

    Vue.filter('computer_name', no => {
      if (!no) { return '-' }
      let computer = Vue.store.getters['computer/getNo']({ no })

      if (!computer) { return '...' }
      return computer.name
    })

    Vue.store = store
    Vue.router = router
    Vue.routerQuery = routerQuery

    Vue.http = http
    Vue.prototype.$http = http

    Vue.dev = dev
    Vue.prototype.$dev = dev

    Vue.request = request
    Vue.prototype.$request = request

    Vue.api = api
    Vue.prototype.$api = api


  },
}
